import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const AltoCusto = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Roteadores de Alto Desempenho</div></Card.Header>
        <Card.Body>
          {/* <Card.Title>Roteadores Robustos</Card.Title> */}
          <Card.Text>
            <div className="opcoes">
              <strong>Custo Elevado:  </strong>
              O investimento inicial é alto, tornando-os inacessíveis para muitos usuários domésticos e pequenas empresas.
            </div>
            <div className="opcoes">
              <strong>Complexidade Técnica: </strong>
              Configuração e manutenção podem ser complexas, exigindo conhecimentos avançados.
            </div>
            <div className="opcoes">
              <strong>Infraestrutura Adicional: </strong>
              Para utilizar todas as funcionalidades, pode ser necessário investir em infraestrutura complementar.
            </div>            
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        {/* <Card.Footer className="text-muted">
        Para garantir uma decisão acertiva ao investir em equipamentos de rede Wi-Fi, é essencial analisar e 
        ponderar o investimento com base nas necessidades específicas de cada cenário
        </Card.Footer> */}
      </Card>
    </>
  )
}
export default AltoCusto;